import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase"; // adjust to your actual init path

const SETTINGS_DOC_PATH = ["settings", "booking"]; // settings/booking


export async function getBookingSettings() {
    const ref = doc(db, ...SETTINGS_DOC_PATH);
    const snap = await getDoc(ref);
    if (!snap.exists()) {
      return {
        blocked_advance: 0,
        admin_notification_email: "",
      };
    }
    return snap.data();
  };

export async function updateBookingSettings({ blocked_advance, admin_notification_email }) {
    const ref = doc(db, ...SETTINGS_DOC_PATH);
    await setDoc(
      ref,
      {
        blocked_advance: Number(blocked_advance),
        admin_notification_email,
        updated_at: serverTimestamp(),
      },
      { merge: true }
    );
    return true;
  };
